var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCtxc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.634 27.545 16.574 3.204a.402.402 0 0 0-.728.335l6.636 18.712a.403.403 0 0 1-.273.521l-4.874 1.342a.403.403 0 0 0 .027.782l13.271 2.648zm-20.518-3.862 1.54-5.197a.327.327 0 0 0-.562-.313l-8.91 10.743h28.485a.334.334 0 0 0 .064-.661l-20.364-4.15a.332.332 0 0 1-.265-.285.336.336 0 0 1 .01-.137zm-9.068 4.313L15.162 3.567l4.561 12.86a.386.386 0 0 1-.647.39l-3.62-3.954a.385.385 0 0 0-.58.01l-13.2 15.564a.387.387 0 0 1-.628-.441z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtxc);
export default __webpack_public_path__ + "static/media/CTXC.c80f22c14be42b2bdab09491ddb1071a.svg";
export { ForwardRef as ReactComponent };